/**
 * © 2026 Grupo Salamander SAPI de CV
 *
 * The one `:focus-visible` ring for every interactive role (plan task 1.2):
 * buttons, links, list items, tabs, chips, menu items, switches and inputs
 * all import this same function rather than drawing their own ring. An
 * accent ring is drawn over a contrast ring so it reads on any ground.
 *
 * `:focus-visible` (native, or `:has(:focus-visible)` for a control whose
 * focusable element is nested, e.g. a filled input's inner `<input>`) already
 * implements "no ring on a mouse click that lands on a non-text control" —
 * the browser's own heuristic, not something this function has to decide.
 */

import { colorConverter } from './colorConverter'
import type { TPaletteDefinition } from './palette'
import { focus } from './tokens'

export function focusRing(palette: TPaletteDefinition, mode: 'light' | 'dark') {
  const accent = colorConverter(palette.primary.main, focus.opacity)
  const contrast =
    mode === 'dark' ? 'rgba(0,0,0,0.85)' : 'rgba(255,255,255,0.95)'
  return {
    outline: 'none',
    boxShadow: [
      `0 0 0 ${focus.contrastWidth}px ${contrast}`,
      `0 0 0 ${focus.contrastWidth + focus.width}px ${accent}`,
    ].join(', '),
  }
}
